import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { InputField } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/formElements/InputField'
import { SearchIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/SearchIcon'
import { XIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/XIcon'
import { UnstyledIconButton } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/unstyledIconButton/UnstyledIconButton'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'
type ClientSearchInputProps = {
  onChange: (text: string) => void
}

const SearchIconContainer = styled.View(({ theme }) => ({
  marginRight: theme.spacing['8px'],
}))

const ClientSearchInput: React.FC<ClientSearchInputProps> = ({ onChange }) => {
  const [searchTextInner, setSearchTextInner] = useState('')
  const intl = useIntl()
  const { colors } = useTheme()
  useEffect(() => {
    onChange(searchTextInner)
  }, [onChange, searchTextInner])

  return (
    <InputField
      testID={tID('ClientSearchInput-input')}
      placeholder={intl.formatMessage({
        defaultMessage: 'Search clients and Lyra ID',
        description: 'Search by name or Lyra ID',
      })}
      baseInputStyle={{ width: 343, marginBottom: 0 }}
      value={searchTextInner}
      onChange={(e) => setSearchTextInner(e.nativeEvent.text)}
      leftIcon={
        <SearchIconContainer>
          <SearchIcon fillColor={colors.iconDefault} />
        </SearchIconContainer>
      }
      inputExtras={
        searchTextInner ? (
          <UnstyledIconButton
            testID={tID('ClientSearchInput-clear-button')}
            onPress={() => setSearchTextInner('')}
            accessibilityLabel={intl.formatMessage({
              defaultMessage: 'Clear search',
              description: 'Clear search button',
            })}
          >
            <XIcon fillColor={colors.iconDefault} />
          </UnstyledIconButton>
        ) : undefined
      }
    />
  )
}

export default ClientSearchInput
